import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=08775396&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=08775396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08775396",
  null
  
)

export default component.exports